/**
 * Divider Component
 * Simple horizontal line divider (no text, unlike Separator)
 */

import { designTokens } from '../../constants/designTokens';

interface DividerProps {
  className?: string;
}

export function Divider({ className = '' }: DividerProps) {
  return (
    <>
      <hr className={`divider ${className}`} />

      <style>{`
        .divider {
          width: 100%;
          height: 1px;
          border: none;
          background-color: ${designTokens.colors.border.light};
          margin: ${designTokens.spacing.lg} 0;
        }

        ${designTokens.media.mobile} {
          .divider {
            margin: ${designTokens.spacing.md} 0;
          }
        }

        ${designTokens.media.desktop} {
          .divider {
            margin: ${designTokens.spacing.xl} 0;
          }
        }
      `}</style>
    </>
  );
}
